module.exports = __webpack_public_path__ + "static/media/sample_upload_eway_expiry.0e41b092.csv";